export const firstDayOfMonth = (month: number, year: number) => {
    return new Date(year, month, 1);
}

export const lastDayOfMonth = (month: number, year: number) => {
    return new Date(year, month + 1, 0);
}

export const formatDate = (data: Date, withTime?: boolean) => {
    let day = data.getDate() < 10 ? '0'+data.getDate() : data.getDate();
    let month = (data.getMonth()+1) < 10 ? '0'+(data.getMonth()+1) : (data.getMonth()+1);
    let year = data.getFullYear();
    let hora = data.getHours() < 10 ? '0'+data.getHours() : data.getHours();
    let minuto = data.getMinutes() < 10 ? '0'+data.getMinutes() : data.getMinutes();
    let segundo = data.getSeconds() < 10 ? '0'+data.getSeconds() : data.getSeconds();

    if (withTime){
        return year+'-'+month+'-'+day+' '+hora+':'+minuto+':'+segundo;    
    }

    return year+'-'+month+'-'+day;
}